import { APIRequest } from './api-service/api-request';
import { ShippingMethod, ShippingMethodsRequestItem } from '../lib/common-interfaces';

export const getShippingMethodsRequest = (items: ShippingMethodsRequestItem[]): Promise<ShippingMethod[]> => {
  const request = new APIRequest();
  return request.post(`${process.env.CHECKOUT_API_URL}/tariffs` as string, items);
};
